import { createContext } from "react";

import { AuthContextState, PERMISSIONS } from "./types";

const AuthContext = createContext({} as AuthContextState);

export default AuthContext;
export { PERMISSIONS };
